import Vue from 'vue';

import BookingApp from './BookingApp';
import ContactUsApp from './ContactApp';

import VueCustomElement from 'vue-custom-element';
import VueMaterial from 'vue-material';
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/black-green-light.css';
import 'document-register-element/build/document-register-element';
import { eventBus } from './components/BookingApp/eventbus';
import routerForBookingApp from "./router/routerForBookingApp";
import storeForBookingApp from "./store/storeForBookingApp";
 
 
BookingApp.store = storeForBookingApp;
BookingApp.router = routerForBookingApp;


Vue.use(VueMaterial);
Vue.use(VueCustomElement);

Vue.config.productionTip = false;

document.onkeydown = function (e) {
  if (e.keyCode == 27) {
    eventBus.closeBookingDialog();
  }
}

Vue.customElement('sneos-booking', BookingApp);

Vue.customElement('sneos-contact-button', ContactUsApp);


(function () {


  // Append CSS file
  var sneosScriptSource = null;
  if (document.currentScript) {
    sneosScriptSource = new URL(document.currentScript.src).origin;
    document.getElementsByTagName("head")[0].insertAdjacentHTML(
      "beforeend",
      "<link rel=\"stylesheet\" href=\"" + sneosScriptSource + "/css/app.css\" />");
  }
})()
